import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { SendMessageDialogComponent } from './send-message-dialog.component';
import { SendMessageDialogService } from './send-message-dialog.service';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SendMessageDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyBadgeModule,
    GalaxyLoadingSpinnerModule,
    MatButtonModule,
    GalaxyPipesModule,
    MatDialogModule,
    MatRadioModule,
    GalaxyFormFieldModule,
    RouterModule,
  ],
  providers: [SendMessageDialogComponent, SendMessageDialogService],
})
export class SendMessageDialogModule {}
